<template>
  <div>
    <vxe-grid
      border
      resizable
      auto-resize
      highlight-hover-row
      size="small"
      :height="400"
      :toolbar-config="tableToolbar"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" style="width: 180px" />
          <p class="no-data mt-2 mb-0">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    loading: { type: Boolean, default: false },
    tableData: { type: Array, default: () => [] },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
